import getHours from './get-hours';

export { getHours };

export default getHours;
